require('popper.js');
require('bootstrap');
require('bootstrap-icons/bootstrap-icons.svg');

import './scss/styles.scss';